import Text from './Text';
import SingleModel from './SingleModel';
import Checkbox from './Checkbox';
import Date from './Date';
import Time from './Time';
import Location from './Location';
import Image from './Image';
import TextArea from './TextArea';
import RichText from './RichText';
import Enum from './Enum';
import ArrayImage from './ArrayImage';
import ArrayModel from './ArrayModel';
import Password from './Password';
import Upload from './Upload';
import Captcha from './Captcha';
import JSONViewer from './JSONViewer';
import ImageSelectAble from './ImageSelectAble'
import ImageViewer from './ImageViewer'
import PageDetail from './customForm/PageDetail';
import FormViewer from './FormViewer';
import EnumButton from './EnumButton'
import EnumMultipleSelect from './EnumMultipleSelect';
import ArrayInput from './ArrayInput';
import ArrayFormViewer from './ArrayFormViewer';
import CVSS from './customForm/CVSS'
import HTML from './HTML'
export default {
  CVSS,
  ArrayFormViewer,
  FormViewer,
  PageDetail,
  ImageSelectAble,
  ImageViewer,
  JSONViewer,
  Time,
  Captcha,
  Upload,
  Password,
  ArrayModel,
  ArrayImage,
  ArrayInput,
  Enum,
  EnumButton,
  EnumMultipleSelect,
  RichText,
  TextArea,
  Image,
  Location,
  Text,
  SingleModel,
  Checkbox,
  Date,
  HTML
};
